module.exports = __webpack_public_path__ + "static/media/sss-off-app-provider-icon.c3c16038.svg";